export default __webpack_public_path__ + "static/media/bg-bottom.492b696f.png";